import DefaultNavbar from 'components/DefaultNavbar';
import DefaultFooter from 'components/DefaultFooter';
import DefaultHeader from 'components/DefaultHeader';
import MobileAppIcon from 'assets/img/hadist-arbain/icon.png';
import SupportSection from 'components/mobile-app/SupportSection';
import HadistArbainContent from "../../components/mobile-app/HadistArbainContent";

export default function HadistArbain() {
    return (
        <>
            <div className="absolute w-full z-20">
                <DefaultNavbar/>
            </div>
            <main>
                <DefaultHeader bg="bg-hadist-background" />
                <HadistArbainContent title="Hadist Arbain" icon={MobileAppIcon}/>
                <SupportSection />
            </main>
            <DefaultFooter />
        </>
    );
}
